import { ResponseGenerator } from 'common/type';
import { trimQueryData } from 'helpers/params';
import { call, put, takeLatest } from 'redux-saga/effects';

import { getHblAPI, getHblDocDetailAPI, uploadHblDocAPI, deleteHblDocAPI, validationHblDocAPI } from './api';
import {
  filterHblDetail,
  filterHblDetailSuccess,
  filterHblFailure,
  getDetailHblDoc,
  getDetailHblDocSuccess,
  getDetailHblDocFailure,
  uploadHblDoc,
  deleteHblDoc,
  getHblDocValidation,
  getHblDocValidationSuccess,
  getHblDocValidationFailure,
} from './slice';
function* fetchHblDetailStatus({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(getHblAPI, trimQueryData(payload));
    yield put(filterHblDetailSuccess(response.data));
  } catch (error) {
    yield put(filterHblFailure());
  }
}

function* fetchHblDocDetail({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(getHblDocDetailAPI, payload);
    yield put(getDetailHblDocSuccess(response));
  } catch (error: any) {
    yield put(getDetailHblDocFailure({ message: error?.message }));
  }
}

function* uploadHblDocSaga({ payload }: any) {
  const { onSuccess, onFail, data } = payload;

  try {
    const response: ResponseGenerator = yield call(uploadHblDocAPI, data);
    if (response.meta.code === 0) {
      onSuccess(response.data);
    } else {
      onFail(response);
    }
  } catch (error) {
    onFail('');
  }
}

function* deleteHblDocSaga({ payload }: any) {
  const { onSuccess, onFail, data } = payload;

  try {
    const response: ResponseGenerator = yield call(deleteHblDocAPI, data);
    if (response.meta.code === 0) {
      onSuccess(response.data);
    } else {
      onFail(response);
    }
  } catch (error) {
    onFail('');
  }
}

function* fetchHblDocValidationSaga({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(validationHblDocAPI, payload);
    yield put(getHblDocValidationSuccess(response));
  } catch (error: any) {
    yield put(getHblDocValidationFailure({ message: error?.message }));
  }
}

function* watchHblStatus() {
  yield takeLatest(filterHblDetail, fetchHblDetailStatus);
  yield takeLatest(getDetailHblDoc, fetchHblDocDetail);
  yield takeLatest(uploadHblDoc, uploadHblDocSaga);
  yield takeLatest(deleteHblDoc, deleteHblDocSaga);
  yield takeLatest(getHblDocValidation, fetchHblDocValidationSaga);
}

export default watchHblStatus;
